
import HttpService from './HttpService'
import ConstDef from '../ConstDef'
import ParamModel from '../domain/ParamModel'
import UserInfoModel from '../domain/UserInfoModel'

export default class LoginByUserIdAndPasswdProc {
  static SendParamModel (userInfo, refreshToken) {
    const jsonObject = {
      proc: 'spLoginByUserIdAndPasswd',
      ps: {
        userId: userInfo.userId,
        passwd: userInfo.passwd,
        refreshToken: refreshToken
      }
    }
    const plainText = JSON.stringify(jsonObject) // '{"version":"20180509.1","userId":"U00488","password":"eluonlbs","session":"nx49ea2hmv","forceCont":true,"receiver":true}'
    const param = new ParamModel()
    param.command = ConstDef.CONNECT
    param.body = plainText
    return HttpService.loginJwt(param)
  }

  static MakeModel (data) {
    let json = JSON.parse(data.body)
    console.log(json)
    let userInfo = new UserInfoModel()
    userInfo.authResult = json.authResult
    userInfo.passwd = json.passwd
    userInfo.userId = json.userId
    userInfo.userName = json.userName
    userInfo.permission = json.permission
    userInfo.userImage = json.userImage
    userInfo.companyCode = json.companyCode
    userInfo.division = json.division
    userInfo.token = json.token
    userInfo.refreshToken = json.refreshToken
    userInfo.userImage = json.userImage
    console.log(userInfo)
    return userInfo
  }
}
